const postalCodes = {
  usa: /^[0-9]{5}(?:-[0-9]{4})?$/,
  canada: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
}

export default postalCodes
